import {
  type Content,
  type ContentHref,
  type Proposal,
  isContentHref,
  isCreateChange,
  isIncludedInRelation,
} from '@generalTypes/apiTypes';
import type { ProposalType } from '../documentUITypes';

export const getProposalType = (
  content: Content,
  proposal: Proposal,
  proposedHrefsToDelete: Array<ContentHref>,
): ProposalType => {
  const href = content.$$meta.permalink;
  if (proposedHrefsToDelete.includes(href)) {
    return 'DELETE';
  }
  if (
    proposal.listOfRequestedChanges.some(
      (c) =>
        isCreateChange(c) &&
        ((c.appliesTo.href === href && isContentHref(c.appliesTo.href)) ||
          (c.relatedTo?.href === href && isIncludedInRelation(c.resource))),
    )
  ) {
    return 'CREATE';
  }
  return 'UPDATE';
};
